import axios from 'axios'
// import { getUser } from './common'

/**
 * Axios request interceptor for adding an authorization token to requests.
 *
 * @param {AxiosRequestConfig} config - The Axios request configuration.
 * @returns {AxiosRequestConfig} - The modified Axios request configuration.
 */
axios.interceptors.request.use(
  async (config:any) => {
    config.headers = {
      ...config.headers,
      // Authorization: `Bearer ${getUser?.token}`,
    }

    return config
  },
  (error) => Promise.reject(error)
)

export const axiosPrivate = axios
